import styled from "styled-components";

export const StyledFrequentlyBought = styled.div`
{
    display: flex;
    width: 29%;
    justify-content: space-between;
    align-items: center;
    margin: 2% 4% 2% 0;

    @media only screen and (max-width: 1500px)  {
        width: 45%;
    }

    @media only screen and (max-width: 767.9px)  {
        width: 100%;
        margin: 0;
    }

    @media only screen and (max-width: 991.9px)  {
        margin: 0;
    }

    .product-content a{
        display: flex;
        flex-direction: row;
        margin-right: 10px;
        align-items: center;

        .product-preview__gallery {
            margin-right: 15px;
        }

        img {
            max-width: 100px;
        }

        .name {
            color: #161616;
            line-height:normal !important;
            font-size: .75rem;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .name-sku {
            color: #161616;
            font-size: .625rem;
            font-weight: 100;
            line-height: normal !important;
        }
    }

    .promotion-preview__header .prices {
        text-align: left !important;
        line-height: normal;
        
        .price {
            font-size: .825rem !important;
            display: inline-block;
        }

        .price--strikethrough {
            font-size: .75rem;
            line-height: 1.3rem;
            position: static;
            display: inline-block;
            margin-right: 8px;
        }
    }

    .ecoPartecipation-frequentlyBought{
        font-weight: 400;
        font-size: .825rem;
    }

    .product-link__buy button.btn_addToCart {
        display: flex;
        align-items: center;
        font-size: .75rem;
        padding: 7px 15px;
        border: none;
        line-height: normal;
        justify-content: center;
        height: fit-content;
        width: auto;

        .icon {
            font-size: 40px;
            font-weight: 100;
            padding-left: 8px;
            margin-top: -3px;

            @media only screen and (max-width: 500px)  {
                padding-left: 0;
            }
        }
    }

}
`;

export const StyledFrequentlyBoughtList = styled.div`
{
    width: 100%;

    .energy_label_text{
        font-size: 12px;
        line-height: normal;
    }

    h2 {
        font-size: 1.5rem;
        font-weight: 700;
    }
    
    .products-list-small {
        width: 100%; 
        display: flex; 
        flex-wrap: wrap; 
        justify-content: flex-start;
    }
    .btn-viewMore {
        border: 0;
        background: none;
        margin: 0 auto;
        font-weight: 700;
        display: flex;
        align-items: flex-end;
        width: 100%;
        justify-content: center;
        color: #000;

        &:hover,
        &:active,
        &:visited {
            color: #000;
        }

        .icon-more {
            font-size: 1.2rem;
            margin-right: 5px;
        }
    }
}
`;